/** Специальные функции для обработки ответов REST сервиса xWiki */

/**
 * Преобразует ответ сервиса в wikis для redux
 */
export const mapWikis = (response) => 
  (response && Array.isArray(response.wikis)? response.wikis.map((wiki, info) => {
    return {
      id: wiki.id, 
      "name": wiki.name, 
      description: wiki.description,
      links: wiki.links.reduce((map, link) => {
        map[link.rel] = link.href
        return map;
      }, {})
    };
  }):[]);


/**
 * Преобразует ответ сервиса в spaces для redux
 */
export const mapSpaces = (response) => 
   (response && Array.isArray(response.spaces)? response.spaces.map((space, info) => {
    return {
      id: space.id, 
      "name": space.name, 
      url: space.xwikiAbsoluteUrl,
      links: space.links.reduce((map, link) => {
        map[link.rel] = link.href
        return map;
      }, {})
    };
  }):[]);


/**
 *  Формирует дерево из линейного списока spaces
 * @param {*} spaces 
 * @returns 
 */
export const makeTreeSpaces = (spaces) => {
  const hashTable = Object.create(null);
  spaces.forEach(space => hashTable[space.id] = {...space, children: []});
  const spacesTree = [];
  spaces.forEach(space => {
    //console.log("helper.js makeTreeSpaces", space.id, space.id.lastIndexOf('.'));
    if(space.id.lastIndexOf('.')<0) 
      spacesTree.push(hashTable[space.id]);
    else {
      const parentID = space.id.substring(0, space.id.lastIndexOf('.'));
      //console.log("helper.js makeTreeSpaces parentID", parentID, hashTable[parentID]);
      if (hashTable[parentID]){
        hashTable[parentID].children.push(hashTable[space.id]);
      } else {
        //Если страница скрыта, то её и вложенные не надо показывать!
        // if(parentID.lastIndexOf('.')<0){
        //   spacesTree.push(hashTable[space.id]);
        // } else {
        //   const parentParentID = parentID.substring(0, parentID.lastIndexOf('.'));
        //   if (hashTable[parentParentID]){
        //     hashTable[parentID].children.push(hashTable[space.id]);
        //     //spacesTree.push(hashTable[space.id]);
        // }
      }
    }
  });
  return spacesTree;  
}
